import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfigurationRoutingModule } from './configuration-routing.module';
import { ConfigurationFilterComponent } from './components/scripts/configurationFilter.component';
import { ConfigurationService } from './services/configuration.service';
import { ConfigurationComponent } from './components/scripts/configuration.component';
import { ConfirmationModalComponent } from './components/scripts/confirmationModal.component';
import { ApplicationTypeaheadComponent } from './components/scripts/application.typeahead.component';
import { MatAutocompleteModule, MatFormFieldModule, MatInputModule } from '@angular/material';
import { ConfigurationEditorModalComponent } from './components/scripts/configurationEditorModal.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { ConfigurationEditorComponent } from './components/scripts/configurationEditor.component';
import { ConfigurationCreateValueFormComponent } from './components/scripts/configurationCreateValueForm.component';
import { ConfigurationCreateApplicationFormComponent } from './components/scripts/configurationCreateApplicationForm.component';

@NgModule({
  imports: [
    AceEditorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    ConfigurationRoutingModule
  ],
  declarations: [
    ConfigurationCreateValueFormComponent,
    ConfigurationCreateApplicationFormComponent,
    ConfigurationEditorComponent,
    ConfigurationEditorModalComponent,
    ConfigurationFilterComponent,
    ConfigurationComponent,
    ConfirmationModalComponent,
    ApplicationTypeaheadComponent
  ],
  providers: [
    ConfigurationService
  ],
  entryComponents: [ConfirmationModalComponent, ConfigurationEditorModalComponent]
})

export class ConfigurationModule { }



// WEBPACK FOOTER //
// ./src/app/configuration/configuration.module.ts